import React from 'react';
import styled from 'styled-components';
import pt from 'prop-types';
import {useStore} from '../../../stores';

const H2 = styled.h2`
    font-family: ${p => p.theme.fonts.brutal.medium};
    font-size: 1.3em;
    margin: 1em 0;
    color: ${p => p.theme.colors.white};
    &&& {
        ${p =>
            p.loading &&
            `
            height: 2.5rem;
            background: ${p.theme.placeholder.color};
            animation: ${p.theme.placeholder.animation};
            position: relative;
            width: 30rem;
            ${p.double &&
                `
            &:after{
                content: '';
                position: absolute;
                width: 30rem;
                height: 2.5rem;
                background: ${p.theme.placeholder.color};
                top: 3.125rem;
                left: 0;
            }`}`} );
    }
`;

const SubTitle = ({className, title, phDl}) => {
    const [{loading}] = useStore();
    return (
        <H2 className={className} loading={loading} double={phDl}>
            {title}
        </H2>
    );
};

SubTitle.propTypes = {
    title: pt.string,
    className: pt.string,
    phDl: pt.bool
};

export default SubTitle;
